import React from 'react'
import './completion-screen.scss'
import { Constants, ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import Loading from '../../common/loading/loading'
import Urls from '../../../apis/url'
import httpClient from '../../../apis/http-client'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component'
import { Link } from 'react-router-dom'
import Path from '../../routes/routes-path'
import moment from 'moment'

class HomeworkAssign extends React.Component {
  state = {
    homeworkDetails: {
      count: 0
    }
  }

  constructor(props) {
    super(props)
    this.state.homeworkDetails = this.props.homeworkDetail
  }



  componentDidMount() {

  }

  convertDate = (date, currentFormat = '', requiredFormat = 'DD MMM YYYY') => {
    return moment(date, currentFormat).format(requiredFormat)
  }

  copyLink = _ => {
    const { homeworkDetails } = this.state
    var dummy = document.createElement('textarea')
    // dummy.style.display = 'none'
    document.body.appendChild(dummy)

    dummy.value = `Dear Students,

    A new assignment has been created for you by ${homeworkDetails.schoolName}, to be completed on the Countingwell App.
    
    Assignment Name: ${homeworkDetails.chapterName}
    Due Date: ${this.convertDate(new Date(homeworkDetails.dueDate))}
    
    You must complete the assignment before this due date.
    
    To view and start the assignment, go to this link: ${homeworkDetails.link}
    
    All the best`
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    this.showToaster('info', 'Copied')
  }

  showToaster(type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster() {
    this.setState({
      showToaster: false
    })
  }

  render() {
    const {
      toasterMessage,
      toasterType,
      showToaster,
      homeworkDetails,
    } = this.state
    return (
      <>
        <div className='container-fluid homework-success-v2'>
          <div className='loader'>
            {this.state.loading && <Loading />}
          </div>
          <div className='row no-gutters'>
            <div className='col-12 p-2 py-3'>
              <img alt='cw-logo' src={getImageSource(ImageConstants.CW_LOGO)} />
            </div>
          </div>
          {!this.state.loading && (
            <div className='row mt-2'>
              <div className='col-lg-6'>
                <div className='homework-success-left'>
                  <img alt=""
                    src={getImageSource(ImageConstants.HOMEWORK_SUCCESS_LEFT)}
                  />
                  <div className='homework-success-left-content'>
                    <div>
                      Homework  assigned to <strong>{homeworkDetails?.count || 0}{' '}
                        students</strong>.
                    </div>
                    <div className='share-title'>
                      Copy this link and share with students to assign them the homework
                    </div>
                    <div className='share-link cursor-pointer' title="Copy Link" onClick={this.copyLink}>
                      {homeworkDetails?.link}
                    </div>
                    <div>
                      <button
                        className={`cw-button-homework`}
                        onClick={this.copyLink}
                      >
                        COPY LINK
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-6'>
                <div className='homework-success-right'>
                  <img
                    alt=""
                    src={getImageSource(ImageConstants.HOMEWORK_SUCCESS_RIGHT)}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        {showToaster ? (
          <div className='custom-toaster-modal'>
            <ToasterComponent
              message={toasterMessage}
              type={toasterType}
              position='bottom-center'
            />
          </div>
        ) : (
          ''
        )}
      </>
    )
  }
}

export default HomeworkAssign
